// extracted by mini-css-extract-plugin
module.exports = {"slidePage":"slidePage--1r1NR","open":"open--29p-h","header":"header--Jq1FD","goBack":"goBack--3AJq_","title":"title--3tbUL"};